
import { createContext, useContext, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

export const CurrentUserContext = createContext();


export function useCurrentUserContext() {
  const [user, setUser] = useContext(CurrentUserContext);
  return { user, setUser };
}


export const withSession = (BaseComponent) => {
  return function EnhancedComponent(props) {
    const { user, setUser } = useCurrentUserContext();
    const navigate = useNavigate();


    useEffect(() => {

      if (!user) {
        console.log("not authenticated")
        navigate("/");
        return;
      }


    }, [])


    return (

      user ?
        <BaseComponent {...props} user={user} />
        :
        <></>
    );
  };
};



export const withSessionOr = (BaseComponent, Else) => {
  return function EnhancedComponent(props) {
    const { user, setUser } = useCurrentUserContext();

    return (
      user ?
        <BaseComponent {...props} user={user} />
        :
        <Else />
    );
  };
};
